// utils/currencyApi.js
import api from '../services/api';
import { formatDateForCNB } from './currencyUtils';

/**
 * Fetches exchange rates from our backend API
 */
export const fetchCNBExchangeRates = async (date) => {
  try {
    if (!date) {
      throw new Error('Date is required');
    }

    const formattedDate = formatDateForCNB(date);
    console.log('Fetching rates for:', formattedDate);

    const { data } = await api.get(`/api/exchange-rates?date=${formattedDate}`);
    
    if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
      throw new Error('Invalid response format');
    }

    return data;
  } catch (error) {
    console.error('Error fetching exchange rates:', error);
    throw error;
  }
};